import {
  BLOCK_TYPE_LABELS,
  type LandingPageBlockValues,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

const REQUIRED_BY_TYPE: Partial<
  Record<LandingPageBlockValues['type'], (keyof LandingPageBlockValues)[]>
> = {
  hero: ['heroHeadline'],
  content: ['contentTitle'],
  closingCta: ['ctaHeadline', 'ctaButtonLabel'],
};

/**
 * Runs on the field array rather than the inputs: a block's fields only register while its
 * accordion is expanded, so per-field rules alone would let a collapsed block save empty.
 */
export function validateLandingPageBlocks(
  blocks: readonly LandingPageBlockValues[] = [],
): string | true {
  const incomplete = blocks.find((block) =>
    (REQUIRED_BY_TYPE[block.type] ?? []).some((field) => !String(block[field] ?? '').trim()),
  );

  if (!incomplete) {
    return true;
  }

  return `${BLOCK_TYPE_LABELS[incomplete.type]} is missing required content.`;
}
